export const awards = {
  awardsHero: {
    subtitle: 'AWARDS & ACTIVITIES',
    title: '受賞・社会活動',
  },
  manifesto: {
    title: 'GLOBAL RECOGNITION',
    subtitle: '国連CSW70フォーラム「卓越した貢献賞」受賞',
    text: {
      paragraph1: {
        line1: '2026年3月10日、ニューヨークで開催された',
        line2: '国連女性の地位委員会第70回会合（CSW70）関連フォーラムにおいて、',
        line3: '当アカデミーの教育フレームワークが国際的な評価を受けました。',
      },
      paragraph2: {
        line1: '脳科学、行動心理学、成功哲学、最新のAIテクノロジーを融合した独自の能力開発プログラムが、',
        line2: '女性のエンパワーメントと持続可能な社会の実現に貢献しているとして、',
        line3: '国連経済社会理事会（ECOSOC）特別協議資格団体であるIDIOより、',
        line4: '代表理事 廣瀬進二へ「Outstanding Contribution Award（卓越した貢献賞）」が授与されました。',
      },
    },
    speech: {
      caption: 'SPEECH AT UN CSW70 FORUM · NEW YORK · 2026',
      heading: 'THE NY MANIFESTO',
      subheading: 'ニューヨーク国際会議 2026 ── 世界への宣言',
      paragraph1: 'すべての人には無限の可能性があります。',
      paragraph2: '教育が思考を変え、思考が行動を変え、行動が人生を変える。\nこの連鎖こそが、持続可能な社会を生み出す最も確実な構造です。',
      paragraph3: 'ジェンダー平等とは、単なる権利の問題ではなく、\n社会全体の成長戦略です。\nDREAM CODEは、誰もが自らの可能性を「構造」として\n設計し直すフレームワークを提供します。',
      paragraph4: '誰一人取り残さない世界へ。\nこれからも世界中の人々が夢を実現できる社会を目指して、\n教育とテクノロジーを融合した取り組みを広げていきます。',
    },
    speechSignature: {
      name: 'Dream Realization Academy 理事長　廣瀬進二',
      date: 'March 10, 2026 / New York',
    },
    signature: {
      line1: 'Dream Realization Academy',
      line2: '理事長　廣瀬進二',
      line3: 'March 10, 2026 / New York',
    },
  },
  initiatives: {
    title: '国連で評価された、3つの社会変革モデル',
    items: [
      {
        title: '自己肯定感と目標達成力の再構築',
        description: 'シングルマザーや女児を対象に、環境に依存しない「自立の構造」を脳科学的アプローチから教育支援します。',
      },
      {
        title: 'ビジネス構造の理解と収入創出',
        description: '単なる支援ではなく、女性起業家向けのビジネス教育プログラムを通じ、持続可能な経済的自立を後押しします。',
      },
      {
        title: '次世代デジタルリーダーの育成',
        description: 'AIとデジタル技術をカリキュラムに統合し、次代の社会を牽引する女性リーダーの認知モデルを形成します。',
      },
    ],
  },
  activities: {
    title: '社会への還元',
    description: 'DREAM CODEの教育体系は、日本国内において企業研修、地域活動、教育支援など、多岐にわたる現場で導入され、再現可能な成果を上げ続けています。',
    link: '社会実装の取り組みを見る',
  },
};